import { Button, FormControl, IButtonProps, Input, Modal, Select, VStack } from 'native-base';
import { useDoctorAppointmentCancel } from '../hooks/useDoctorAppointmentCancel';
import React from 'react';

export function DoctorAppointmentCancelButton({
  appointmentID,
  variant = 'outline',
  size = 'sm',
  title = 'Cancel Appointment',
  flex,
  onCancel,
}: { appointmentID: string; title?: string; onCancel?: () => void } & Pick<
  IButtonProps,
  'variant' | 'size' | 'flex'
>) {
  const {
    showModal,
    setShowModal,
    setType,
    type,
    notes,
    setNotes,
    canSubmit,
    loading,
    cancelAppointment,
  } = useDoctorAppointmentCancel(appointmentID, onCancel);

  return (
    <>
      <Button
        flex={flex}
        _text={{ numberOfLines: 1 }}
        size={size}
        variant={variant}
        onPress={() => setShowModal(true)}
      >
        {title}
      </Button>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
        <Modal.Content>
          <Modal.CloseButton />
          <Modal.Header>Cancel Appointment</Modal.Header>
          <Modal.Body>
            <VStack space={2}>
              <FormControl>
                <FormControl.Label>Reason</FormControl.Label>

                <Select
                  selectedValue={type ?? 'select'}
                  onValueChange={(e) => setType(e)}
                  isDisabled={loading}
                >
                  <Select.Item label={'Select reason'} value={'select'} />
                  <Select.Item label={'Cancel'} value={'cancel'} />
                  <Select.Item label={'No Show'} value={'noshow'} />
                  <Select.Item label={'Park'} value={'park'} />
                </Select>
              </FormControl>

              <FormControl>
                <FormControl.Label>Notes</FormControl.Label>

                <Input
                  isDisabled={loading}
                  value={notes}
                  onChangeText={(e) => setNotes(e)}
                  multiline={true}
                />
              </FormControl>
            </VStack>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onPress={cancelAppointment}
              opacity={canSubmit ? 1 : 0.5}
              isLoading={loading}
              disabled={!canSubmit}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    </>
  );
}
